import { all, call, put, takeLatest } from "redux-saga/effects";
import { MONEY_CONVERT_DATA, MoneyConvertDataSuccess } from "../actions/index";

const getMoneyConvertData = async (req) => {
  const res = await fetch("https://api.transferwise.com/v3/comparisons/?sourceCurrency=EUR&targetCurrency=INR&sendAmount="+req);
  const data = await res.json();
  return data;
};

function* fetchMoneyConvertData(action) {
  try {
    // if (convertedData.data) {
    //   yield put(MoneyConvertDataSuccess(convertedData.data));
    // }
    const convertedData = yield call(getMoneyConvertData, action.sendingAmount);
    //console.log("resp?.data", convertedData);
    if (convertedData) {
      //let isOTP_sent= true;
      let ComparisonData = convertedData ? convertedData : [];
      yield put(MoneyConvertDataSuccess(ComparisonData));
    } else {
    }
  } catch (e) {
    // yield put({ type: 'USER_FETCH_FAILED', message: e.message })
    console.log(e);
  }
}

function* MoneyConvertDataSaga() {
  yield takeLatest(MONEY_CONVERT_DATA, fetchMoneyConvertData);
}

export default function* rootSaga() {
  yield all([MoneyConvertDataSaga()]);
}
